import React, { Component } from 'react';
import { connect } from 'react-redux';
import { destandard } from '../../utils/commonFunctions';
import RetailerIncentivePerformances from './retailer-incentive-performances';

class RetailerPerformance extends Component {

  render() {
    const { performances, current_user } = this.props;

    if (!performances) {
      return null;
    }

    return (
      <div>
        {
          performances.map((value, key) => {
            const performance = destandard({...value.attributes});

            return (
              <RetailerIncentivePerformances
                {...performance}
                key={value.id}
                index={key}
                outlet={value.id}
                current_user={current_user}
              />
            );
          })
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    performances: state.stores.performances,
    current_user: state.viewConfig.profile,
  };
};

export default connect(mapStateToProps)(RetailerPerformance);


// WEBPACK FOOTER //
// ./src/components/store-performance/retailer-performance.jsx